<template lang="pug">
.loader.position-relative.w-100.h-100(
  :class="[{ 'loader--fullPage position-fixed bottom-0 start-0': isFullPage }, { 'loader--background': isClear }, { 'loader--backgroundWhite': hasBackground }]"
  :aria-busy="true"
)
  .loader__content.position-absolute.d-flex.align-items-center.justify-content-center.top-0.start-0.end-0.bottom-0
    .sk-fading-circle.position-relative(:class="{ 'clear': isClear }")
      slot
        span.sk-circle.position-absolute.top-0.start-0.w-100.h-100(v-for="n in 12" :key="n" :class="`sk-circle${n}`")
</template>

<script>
export default {
  name: 'SpinnerLoader',
  props: {
    isClear: {
      type: Boolean,
      default: false,
    },
    isFullPage: {
      type: Boolean,
      default: false,
    },
    hasBackground: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '#333', // Default color for the loader
    },
  },
};
</script>

<style scoped lang="scss">
/* Root loader styles */
.loader.loader--fullPage {
  z-index: 99999;
}

.loader.loader--background {
  background: rgb(0 0 0 / 80%);
}

.loader.loader--backgroundWhite {
  background: rgb(255 255 255 / 70%);
  backdrop-filter: saturate(180%) blur(10px);
}

/* Loader animation */
.sk-fading-circle {
  width: 40px;
  aspect-ratio: 1 / 1;

  .sk-circle {
    &::before {
      content: '';
      display: block;
      width: 15%;
      height: 15%;
      margin: 0 auto;
      background-color: var(--loader-color, v-bind('color'));
      animation: sk-circle-fade-delay 1.2s infinite ease-in-out both;
      border-radius: 100%;
    }
  }

  &.clear {
    .sk-circle {
      &::before {
        background-color: #fff;
      }
    }
  }

  .sk-circle2 {
    transform: rotate(30deg);
  }

  .sk-circle3 {
    transform: rotate(60deg);
  }

  .sk-circle4 {
    transform: rotate(90deg);
  }

  .sk-circle5 {
    transform: rotate(120deg);
  }

  .sk-circle6 {
    transform: rotate(150deg);
  }

  .sk-circle7 {
    transform: rotate(180deg);
  }

  .sk-circle8 {
    transform: rotate(210deg);
  }

  .sk-circle9 {
    transform: rotate(240deg);
  }

  .sk-circle10 {
    transform: rotate(270deg);
  }

  .sk-circle11 {
    transform: rotate(300deg);
  }

  .sk-circle12 {
    transform: rotate(330deg);
  }

  .sk-circle2::before {
    animation-delay: -1.1s;
  }

  .sk-circle3::before {
    animation-delay: -1s;
  }

  .sk-circle4::before {
    animation-delay: -0.9s;
  }

  .sk-circle5::before {
    animation-delay: -0.8s;
  }

  .sk-circle6::before {
    animation-delay: -0.7s;
  }

  .sk-circle7::before {
    animation-delay: -0.6s;
  }

  .sk-circle8::before {
    animation-delay: -0.5s;
  }

  .sk-circle9::before {
    animation-delay: -0.4s;
  }

  .sk-circle10::before {
    animation-delay: -0.3s;
  }

  .sk-circle11::before {
    animation-delay: -0.2s;
  }

  .sk-circle12::before {
    animation-delay: -0.1s;
  }
}

@keyframes sk-circle-fade-delay {
  0%,
  39%,
  100% {
    opacity: 0;
  }

  40% {
    opacity: 1;
  }
}

@keyframes sk-circle-fade-delay {
  0%,
  39%,
  100% {
    opacity: 0;
  }

  40% {
    opacity: 1;
  }
}
</style>
